import ExperimentUtils, { IMMEDIATE_FEATURES } from 'utils/experiment';
import { FacilityCountries } from 'utils/types/facility';
export const showInsuranceUpsell = ({ isAirport, country, insuranceAddon, purchaseForCustomer, }) => {
    return Boolean(!purchaseForCustomer &&
        insuranceAddon &&
        country === FacilityCountries.US &&
        isAirport &&
        ExperimentUtils.isFeatureEnabled(IMMEDIATE_FEATURES.AIRPORT_INSURANCE_UPSELL));
};
